import { Address } from '../../types/interfaces';

export function formatAddress(address: Address): string | undefined {
  if (address) {
    const { country, region, city, street, house, apartment, postcode } = address;
    return `${country}, ${region}, ${city}, ${street}, дом ${house}, офис. ${apartment}, почтовый индекс ${postcode}`;
  }
}
